var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMap = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.219 4.625a1.454 1.454 0 0 1-1.447-1.46c0-.808.648-1.461 1.447-1.461.8 0 1.447.653 1.447 1.46 0 .807-.648 1.461-1.447 1.461zm0 3.872s3.007-3.786 3.007-5.462C14.226 1.359 12.88 0 11.219 0c-1.66 0-3.007 1.359-3.007 3.035 0 1.676 3.007 5.462 3.007 5.462zm-6.996 7.306-3.127-1.3V5.467l3.127 1.299v9.037zM16 15.615V4.185l-1.131-.608a6.358 6.358 0 0 1-.393 1.034l.428.315v9.037l-3.126-1.3V8.569a21.5 21.5 0 0 1-.236.304l-.323.406-.322-.406c-.039-.049-.114-.144-.215-.276v4.522l-5.364 2.23V6.311l2.833-.981A8.72 8.72 0 0 1 7.7 4.32L4.223 5.57 0 3.814v11.43L4.223 17l7.555-3.14L16 15.615z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map.ace39eaf.svg";
export { ForwardRef as ReactComponent };